import AdminReportView from '../components/Admin/Reports/View';
import { getIntl } from './IntlInstance';

export const reports = (intlInstance) => {
  let intl;
  if (!intlInstance) {
    intl = getIntl();
  } else {
    intl = intlInstance;
  }

  return [
    {
      id: 'most-active-users',
      widget: true,
      icon: 'fa-list',
      name: intl.formatMessage({ defaultMessage: 'Most active users' }),
      type: 'table',
      period: true,
      defaultPeriod: 'by_month',
      component: AdminReportView,
    },
    {
      id: 'storage',
      widget: true,
      icon: 'fa-chart-line',
      name: intl.formatMessage({ defaultMessage: 'Platform storage' }),
      tooltipTitle: intl.formatMessage({ defaultMessage: 'Storage:' }),
      type: 'chart',
      chartType: 'line',
      granularity: true,
      component: AdminReportView,
    },
    {
      id: 'total-files',
      widget: true,
      icon: 'fa-chart-line',
      name: intl.formatMessage({ defaultMessage: 'Total number of files' }),
      tooltipTitle: intl.formatMessage({ defaultMessage: 'Files:' }),
      type: 'chart',
      chartType: 'line',
      granularity: true,
      formatter: 'number',
      component: AdminReportView,
    },
    {
      id: 'total-collections',
      widget: true,
      icon: 'fa-chart-line',
      name: intl.formatMessage({ defaultMessage: 'Total number of collections' }),
      tooltipTitle: intl.formatMessage({ defaultMessage: 'Collections:' }),
      type: 'chart',
      chartType: 'line',
      granularity: true,
      formatter: 'number',
      component: AdminReportView,
    },
    {
      id: 'search-terms',
      widget: true,
      icon: 'fa-list',
      name: intl.formatMessage({ defaultMessage: 'Search terms' }),
      type: 'table',
      period: true,
      defaultPeriod: 'by_month',
      component: AdminReportView,
    },
    {
      id: 'assets-by-type',
      widget: true,
      icon: 'fa-chart-pie-simple',
      name: intl.formatMessage({ defaultMessage: 'Assets by type' }),
      type: 'chart',
      chartType: 'pie',
      formatter: 'number',
      defaultDateFrom: '2000-01-01',
      component: AdminReportView,
    },
    {
      id: 'total-users',
      widget: true,
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Total number of users' }),
      tooltipTitle: intl.formatMessage({ defaultMessage: 'Users:' }),
      type: 'chart',
      chartType: 'bar',
      granularity: true,
      component: AdminReportView,
    },
    {
      id: 'new-users',
      widget: true,
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Total number of new users' }),
      tooltipTitle: intl.formatMessage({ defaultMessage: 'New users:' }),
      type: 'chart',
      chartType: 'bar',
      granularity: true,
      component: AdminReportView,
    },
    {
      id: 'most-downloaded',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Most downloaded files' }),
      taxonomiesFilter: true,
      component: AdminReportView,
    },
    {
      id: 'most-viewed',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Most viewed files' }),
      component: AdminReportView,
    },
    {
      id: 'most-viewed-public-urls',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Most viewed Public URLs' }),
      component: AdminReportView,
    },
    {
      id: 'downloads-by-team',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Downloads by Team' }),
      component: AdminReportView,
    },
    {
      id: 'downloads-by-user',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Downloads by user' }),
      component: AdminReportView,
    },
    {
      id: 'shares-by-user',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Shares by user' }),
      component: AdminReportView,
    },
    {
      id: 'download-requests-by-user',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Download requests by user' }),
      component: AdminReportView,
    },
    {
      id: 'download-requests-by-team',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Download requests by Team' }),
      component: AdminReportView,
    },
    {
      id: 'download-requests-by-admin',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Download requests report' }),
      component: AdminReportView,
    },
    {
      id: 'approved-accounts-by-admin',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Approved accounts by admin' }),
      component: AdminReportView,
    },
    {
      id: 'collections',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Collection access' }),
      datePicker: false,
      userPicker: true,
      component: AdminReportView,
    },
    {
      id: 'downloaded-files',
      icon: '',
      name: intl.formatMessage({ defaultMessage: 'Downloaded files' }),
      datePicker: true,
      userPicker: true,
      pagination: true,
      component: AdminReportView,
    },
  ];
};

export const reportPeriods = (intlInstance) => {
  let intl;
  if (!intlInstance) {
    intl = getIntl();
  } else {
    intl = intlInstance;
  }

  return [
    {
      id: 'by_day',
      granularityText: intl.formatMessage({ defaultMessage: 'by day' }),
      periodText: intl.formatMessage({ defaultMessage: 'last day' }),
    },
    {
      id: 'by_week',
      granularityText: intl.formatMessage({ defaultMessage: 'by week' }),
      periodText: intl.formatMessage({ defaultMessage: 'last week' }),
    },
    {
      id: 'by_month',
      granularityText: intl.formatMessage({ defaultMessage: 'by month' }),
      periodText: intl.formatMessage({ defaultMessage: 'last month' }),
    },
    {
      id: 'by_year',
      granularityText: intl.formatMessage({ defaultMessage: 'by year' }),
      periodText: intl.formatMessage({ defaultMessage: 'last year' }),
    },
  ];
};
